import React, { useState, useEffect } from 'react';
import ScheduleFilters from './ScheduleFilters';
import ScheduleDisplay from './ScheduleDisplay';
import { api } from '../utils/api';

function SchedulePage({ organization, organizationName, onBack }) {
  const [activeTab, setActiveTab] = useState('students');
  const [groups, setGroups] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, [organization]);

  // Очищаем расписание при переключении вкладок
  useEffect(() => {
    setSchedule([]);
  }, [activeTab]);

  const loadInitialData = async () => {
    try {
      const [groupsData, teachersData] = await Promise.all([
        api.getGroups(organization),
        api.getTeachers(organization)
      ]);
      setGroups(groupsData);
      setTeachers(teachersData);
    } catch (error) {
      alert('Ошибка загрузки данных: ' + error.message);
    }
  };

  const handleLoadSchedule = async (type, params) => {
    setLoading(true);
    try {
      let scheduleData;
      if (type === 'group') {
        scheduleData = await api.getGroupSchedule(
          organization,
          params.guid,
          params.dateFrom,
          params.dateTo
        );
      } else if (type === 'teacher') {
        scheduleData = await api.getTeacherSchedule(
          organization,
          params.guid,
          params.dateFrom,
          params.dateTo
        );
      } else {
        alert('API для расписания по аудитории не указано в задании');
        return;
      }
      setSchedule(scheduleData);
    } catch (error) {
      alert('Ошибка загрузки расписания: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page active">
      <header className="schedule-header">
        <a 
          href="/" 
          className="back-logo" 
          title="Вернуться на главную"
        >
          <img 
            src={organization === 'college' ? '/img/logo%20urk.png' : '/img/logo-yutu.png'} 
            alt="Логотип" 
            className="back-logo-img"
          />
        </a>
        <h1>
          {organization === 'college' 
            ? 'Расписание Уральского регионального колледжа'
            : 'Расписание Южно-Уральского технологического университета'}
        </h1>
      </header>
      <div className="schedule-content">
        <nav className="tabs">
          <button
            className={`tab ${activeTab === 'students' ? 'active' : ''}`}
            onClick={() => setActiveTab('students')}
          >
            СТУДЕНТАМ
          </button>
          <button
            className={`tab ${activeTab === 'teachers' ? 'active' : ''}`}
            onClick={() => setActiveTab('teachers')}
          >
            ПРЕПОДАВАТЕЛЯМ
          </button>
        </nav>

        <ScheduleFilters
          activeTab={activeTab}
          groups={groups}
          teachers={teachers}
          onLoadSchedule={handleLoadSchedule}
          loading={loading}
        />

        <ScheduleDisplay schedule={schedule} activeTab={activeTab} />
      </div>
    </div>
  );
}

export default SchedulePage;


